import React from 'react';
import {
  RelatedContentDto,
  VideoRelatedContentPropsDto
} from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexItem } from '../../components/flex/FlexItem.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { getRelatedContentVideoDurationDisplay } from './ai-chat.utilities';
import { ELSIcon } from '@els/els-component-form-field-react';

export type RelatedContentVideoProps = {
  relatedContent: RelatedContentDto;
  onClick?: (relatedContent: RelatedContentDto) => void;
}

export const RelatedContentVideoComponent = (props: RelatedContentVideoProps): JSX.Element => {
  const { relatedContent, onClick } = props;
  const contentProps = relatedContent.contentProps as VideoRelatedContentPropsDto;

  if (!contentProps?.sections_video_muxThumbSmall) {
    return <div className="u-els-padding">{relatedContent.title}</div>;
  }

  const duration = getRelatedContentVideoDurationDisplay(relatedContent);
  const src = `https://d16qt3wv6xm098.cloudfront.net/${contentProps?.sections_video_muxThumbSmall}`;

  const handleClick = () => {
    if (onClick) {
      onClick(relatedContent);
    }
  };

  return (
    <button
      className="u-els-debuttonize c-els-related-content-video"
      title={relatedContent.title}
      onClick={handleClick}
    >
      <div className="c-els-related-content-video__wrapper">
        <div
          role="img"
          aria-label={relatedContent.title}
          className="c-els-related-content-video__image"
          style={{
            backgroundImage: `url(${src})`
          }}
        />

        <div className="c-els-related-content-video__link-icon-wrapper">
          <ELSIcon
            prefix="gizmo"
            name="expand"
            size="1x1o2"
            customClass="c-els-related-content-video__link-icon"
          />
        </div>


        {duration && (
          <div className="c-els-related-content-video__duration">
            <FlexLayout modifiers={[
              FlexLayoutModifier.GUTTERS_1o2,
              FlexLayoutModifier.CENTER,
              FlexLayoutModifier.MIDDLE,
            ]}>
              <FlexItem>
                <ELSIcon
                  prefix="gizmo"
                  name="play-video"
                  size="1x"
                  customClass="c-els-related-content-video__icon"
                />
              </FlexItem>
              <FlexItem>
                {duration}
              </FlexItem>
            </FlexLayout>
          </div>
        )}
      </div>
      <div className="c-els-related-content-video__title">{relatedContent.title}</div>
    </button>
  );
};

const RelatedContentVideo = RelatedContentVideoComponent;
export default RelatedContentVideo;
